import React from 'react';
import { Video, Play, Download, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function VideoGenerator({ token }) {
  const { t } = useTranslation();

  return (
    <div className="max-w-2xl mx-auto p-6" data-testid="video-studio-coming-soon">
      <div className="text-center py-16">
        <div className="w-24 h-24 bg-gradient-to-br from-orange-100 to-orange-200 dark:from-orange-900/30 dark:to-orange-800/30 rounded-full flex items-center justify-center mx-auto mb-8">
          <Video className="w-12 h-12 text-[#FF6600]" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Video Studio
        </h1>
        <div className="inline-block bg-[#FF6600]/10 text-[#FF6600] px-4 py-2 rounded-full text-sm font-semibold mb-6">
          Coming Soon
        </div>
        <p className="text-gray-500 dark:text-gray-400 text-lg max-w-md mx-auto mb-8">
          We're preparing this feature for you. Create stunning AI-powered fitness and nutrition videos with Sora 2.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-lg mx-auto">
          <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm">
            <Sparkles className="w-6 h-6 text-[#FF6600] mx-auto mb-2" />
            <p className="text-xs text-gray-500 dark:text-gray-400">AI-Powered Generation</p>
          </div>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm">
            <Play className="w-6 h-6 text-[#FF6600] mx-auto mb-2" />
            <p className="text-xs text-gray-500 dark:text-gray-400">4K Quality Videos</p>
          </div>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm">
            <Download className="w-6 h-6 text-[#FF6600] mx-auto mb-2" />
            <p className="text-xs text-gray-500 dark:text-gray-400">Easy Download & Share</p>
          </div>
        </div>
      </div>
    </div>
  );
}
